import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const ticketsTexts: Record<string, IOnboardingStepText> = {
  'tickets.intro': {
    title: 'Заявки',
    text: 'Здесь сотрудники сообщают о неполадках: сломался принтер, протекает кран, нужен ремонт. Покажем, как всё устроено.',
  },
  'tickets.create': {
    title: 'Новая заявка',
    text: 'Опишите проблему, выберите службу и категорию — заявка уйдёт ответственным.',
  },
  'tickets.statistics': {
    title: 'Статистика',
    text: 'Графики по заявкам: сколько поступает, в каком статусе, по каким службам.',
  },
  'tickets.reports': {
    title: 'Отчёты',
    text: 'Сводные таблицы по координаторам, отделениям и категориям за выбранный период.',
  },
  'tickets.settings': {
    title: 'Настройки',
    text: 'Справочники модуля: категории заявок и группы исполнителей. Доступны администраторам.',
  },
  'tickets.navSettings': {
    title: 'Настройки в боковом меню',
    text: 'Те же настройки открываются с любой страницы: наведите на пункт «Заявки» в боковом меню — появится шестерёнка.',
  },
  'tickets.categories.tree': {
    title: 'Категории заявок',
    text: 'Дерево категорий. У категории есть служба, группа исполнителей и ответственный — по ним заявка находит своих исполнителей.',
  },
  'tickets.categories.filter': {
    title: 'Свои и глобальные',
    text: 'Глобальные категории приходят от ДаоМед, их можно только включать и выключать. Свои категории редактируются полностью.',
  },
  'tickets.categories.view': {
    title: 'Вид дерева',
    text: 'Компактный режим, скрытие иерархии и перетаскивание категорий мышью.',
  },
  'tickets.categories.create': {
    title: 'Новая категория',
    text: 'Добавьте категорию и укажите службу и группу исполнителей.',
  },
  'tickets.workGroups.table': {
    title: 'Группы исполнителей',
    text: 'Сотрудники, которые выполняют заявки категории. Изменения в группе сохраняются сразу.',
  },
  'tickets.workGroups.add': {
    title: 'Новая группа',
    text: 'Создайте группу и добавьте в неё сотрудников, затем привяжите её к категории.',
  },
  'tickets.export': {
    title: 'Выгрузка',
    text: 'Скачать заявки в Excel с учётом текущих фильтров.',
  },
  'tickets.search': {
    title: 'Поиск',
    text: 'Введите слово или номер и нажмите Enter.',
  },
  'tickets.hideCompleted': {
    title: 'Скрыть завершённые',
    text: 'Включено по умолчанию: в списке только незавершённые заявки. Выключите, чтобы найти уже выполненную. «Сбросить фильтры» переключатель не трогает.',
  },
  'tickets.requiresAction': {
    title: 'Требует действия',
    text: 'Покажет только заявки, где ждут именно вас. Такие строки отмечены красной полосой слева.',
  },
  'tickets.filters': {
    title: 'Фильтры колонок',
    text: 'Значок в заголовке колонки открывает фильтр по ней. Фильтры можно сочетать.',
  },
  'tickets.resetFilters': {
    title: 'Сброс фильтров',
    text: 'Возвращает таблицу к виду по умолчанию.',
  },
  'tickets.demoRow': {
    title: 'Карточка заявки',
    text: 'Клик по строке открывает заявку. Откроем учебную — в ней заполнены все поля.',
  },
  'tickets.form.serviceCategory': {
    title: 'Служба и категория',
    text: 'Связаны между собой: категория сама подставит службу, а служба сузит список категорий.',
  },
  'tickets.form.departmentLocation': {
    title: 'Где проблема',
    text: 'Отделение и конкретное помещение — чтобы исполнитель сразу знал, куда идти.',
  },
  'tickets.form.files': {
    title: 'Файлы',
    text: 'Приложите фото или документ. Скриншот можно вставить сочетанием Ctrl+V.',
  },
  'tickets.form.assignSelf': {
    title: 'Назначить себя',
    text: 'Вы в группе исполнителей этой категории — можете взять заявку на себя.',
  },
  'tickets.form.save': {
    title: 'Сохранение',
    text: 'Изменения в полях сохраняются только по этой кнопке.',
  },
  'tickets.form.historyTab': {
    title: 'История',
    text: 'Кто и когда менял заявку.',
  },
  'tickets.form.tasksEar': {
    title: 'Задача по заявке',
    text: 'Работа по заявке ведётся в задаче координатора: здесь назначают координатора, ставят срок и отчитываются.',
  },
  'tickets.form.assignCoordinator': {
    title: 'Координатор',
    text: 'Пока координатор не назначен, заявка никуда не движется. Назначьте его здесь.',
  },
}
